import { render } from "./ellipsis.html?vue&type=template&id=59397120&scoped=true&ts=true"
import script from "./ellipsis.ts?vue&type=script&lang=ts"
export * from "./ellipsis.ts?vue&type=script&lang=ts"

import "./ellipsis.scss?vue&type=style&index=0&id=59397120&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59397120"]])

export default __exports__